import axios from 'axios'

const URL = '/ata-registro-preco/api/public/configuracao'

class ParametrosSistemaApiClient {
	async buscarTodosParametros() {
		return await axios.get(`${URL}/parametrosSistema`)
	}
}

export default new ParametrosSistemaApiClient()
